import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import React from 'react';
// -*- mode: jsx;-*-
/* global dc */
import { detectLocation } from './detectLocation.js';


/**
 * A component that looks up the user's location and passes it as a prop
 * to its child. Also forwards any provided props to the child.
 *
 * It passes location = null to the child until the lookup finishes.
 */
export const WithLocation = createReactClass({
    propTypes: {
        location: PropTypes.object,
        setLocation: PropTypes.func.isRequired,
        children: PropTypes.element.isRequired,
    },

    getInitialState() {
        return {
            location: this.props.location,
        };
    },

    componentDidMount() {
        // on desktop, maxMind does geocoding on page load
        // on mobile, navigator.geolocation is used instead, usually after a user action since the browser alert is noisy
        if (!this.props.location) {
            detectLocation(this.updateLocation);
            // googlePlacesLoaded was loaded with the page, so we need to trigger this event again
            $(document).trigger('googlePlacesLoaded');
        }
    },

    updateLocation(location) {
        this.setState({
            location: location,
        });
        this.props.setLocation(location);
    },

    renderChildren() {
        var component = this;

        return React.Children.map(component.props.children, function (child) {
            return React.cloneElement(child, {
                location: component.state.location,
            });
        });
    },

    render() {
        return <div>{this.renderChildren()}</div>;
    },
});
